<template>
    <v-card  :loading="loadingOperating || loadingAlarmsCount || loadingIncidents || loadingIntrusions">
        <v-card-title class="grey lighten-2 text-h5 font-weight-bold">
            {{ $vuetify.lang.t('$vuetify.dashboard.statistics.statistics') }}
            <v-spacer />
            <v-btn icon color="black" outlined @click="refresh">
                <v-icon>mdi-refresh</v-icon>
            </v-btn>
        </v-card-title>
        <v-card flat class="overflow-y-auto" max-height="350px">
            <v-skeleton-loader
                v-if="loadingOperating || loadingAlarmsCount || loadingIncidents || loadingIntrusions"
                type="table-tbody"
            ></v-skeleton-loader>
            <v-container v-else fluid>
                <v-row>
                    <v-col cols="12" md="6" lg="6">
                        <v-card flat min-height="200" class="fill-height d-flex flex-column">
                            <v-row align="center" justify="center" no-gutters class="flex-grow-0">
                                <v-col cols="auto">
                                    <v-icon size="20">mdi-alarm-light</v-icon>
                                </v-col>
                                <v-col cols="auto">
                                    <v-card-title class="py-2 pr-2">{{ $vuetify.lang.t('$vuetify.dashboard.statistics.alarmperutc') }}</v-card-title>
                                </v-col>
                            </v-row>
                            <v-row v-if="alarmsLabels.length == 0" align="center" justify="center" no-gutters>
                                <v-col cols="auto">
                                    {{ $vuetify.lang.t('$vuetify.dashboard.statistics.noDataAlarmsCount') }}
                                </v-col>
                            </v-row>
                            <Bar
                                v-else
                                :chart-options="chartOptionsAlarms"
                                :chart-data="chartDataAlarms"
                                :height="35"
                                :width="80"
                            />
                        </v-card>
                    </v-col>
                    <v-col cols="12" md="6" lg="6">
                        <v-card flat min-height="200" class="fill-height d-flex flex-column">
                            <v-row align="center" justify="center" no-gutters class="flex-grow-0">
                                <v-col cols="auto">
                                    <v-icon size="20">mdi-motion-sensor</v-icon>
                                </v-col>
                                <v-col cols="auto">
                                    <v-card-title class="py-2 pr-2">{{ $vuetify.lang.t('$vuetify.dashboard.statistics.intrusionperutc') }}</v-card-title>
                                </v-col>
                            </v-row>
                            <v-row v-if="intrusionsLabels.length == 0" align="center" justify="center" no-gutters>
                                <v-col cols="auto">
                                    {{ $vuetify.lang.t('$vuetify.dashboard.statistics.noIntrusions') }}
                                </v-col>
                            </v-row>
                            <Bar
                                v-else
                                :chart-options="chartOptionsIntrusions"
                                :chart-data="chartDataIntrusions"
                                :height="35"
                                :width="80"
                            />
                        </v-card>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" md="6" lg="6">
                        <v-card flat min-height="200" class="fill-height d-flex flex-column">
                            <v-row align="center" justify="center" no-gutters class="flex-grow-0">
                                <v-col cols="auto">
                                    <v-icon size="20">mdi-clock</v-icon>
                                </v-col>
                                <v-col cols="auto">
                                    <v-card-title class="py-2 pr-2">{{ $vuetify.lang.t('$vuetify.dashboard.statistics.operatingtime') }}</v-card-title>
                                </v-col>
                            </v-row>
                            <v-row v-if="operatingTimeLabels.length == 0" align="center" justify="center" no-gutters>
                                <v-col cols="auto">
                                    {{ $vuetify.lang.t('$vuetify.dashboard.statistics.noDataOperationTime') }}
                                </v-col>
                            </v-row>
                            <Bar
                                v-else
                                :chart-options="chartOptionsOperatingTime"
                                :chart-data="chartDataOperatingTime"
                                :height="35"
                                :width="80"
                            />
                        </v-card>
                    </v-col> 
                    <v-col cols="12" md="6" lg="6">
                        <v-card flat min-height="200" class="fill-height d-flex flex-column">
                            <v-row align="center" justify="center" no-gutters class="flex-grow-0">
                                <v-col cols="auto">
                                    <v-icon size="20">mdi-bug</v-icon>
                                </v-col>
                                <v-col cols="auto">
                                    <v-card-title class="py-2 pr-2">{{ $vuetify.lang.t('$vuetify.dashboard.statistics.incidentperutc') }}</v-card-title>
                                </v-col>
                            </v-row>
                            <v-row v-if="incidentsLabels.length == 0" align="center" justify="center" no-gutters>
                                <v-col cols="auto">
                                    {{ $vuetify.lang.t('$vuetify.dashboard.statistics.noIncidents') }}
                                </v-col>
                            </v-row>
                            <Bar
                                v-else
                                :chart-options="chartOptionsIncidents"
                                :chart-data="chartDataIncidents"
                                :height="35"
                                :width="80"
                            />
                        </v-card>
                    </v-col>             
                </v-row>
            </v-container>
        </v-card>
    </v-card>
</template>
<script>

import axios from 'axios';
import { Bar  } from 'vue-chartjs/legacy'
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import waitForElm from '../../plugins/waitForElm';
import { mapGetters } from 'vuex';

ChartJS.register(ChartDataLabels, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale);

export default {
    name: "StatisticsCard",
    components: { Bar },
    data() {
        return {
            loadingOperating: true,
            loadingAlarmsCount: true,
            loadingIncidents: true,
            loadingIntrusions: true,
            // realDateLastUpdateStat: undefined,

            operatingTimeBg: "#1E90FF",
            operatingTimeLabels: [],
            operatingTimeData: [],

            alarmsBg: "#1E90FF",
            alarmsLabels: [],
            alarmsData: [],

            incidentsBg: "#1E90FF",
            incidentsLabels: [],
            incidentsData: [],

            intrusionsBg: "#1E90FF",
            intrusionsLabels: [],
            intrusionsData: [],

            chartOptionsOperatingTime: {
                responsive: true,
                indexAxis: 'y',
                scales: {
                    x: {
                        stacked: false,
                        grid: {
                            display: false
                        }, 
                        ticks: {
                            display: false
                        },
                        title: {
                            display: true,
                            text: this.$vuetify.lang.t('$vuetify.dashboard.statistics.time'),
                        },
                    },
                    y: {
                        stacked: false,
                        grid: {
                            display: false
                        },
                        title: {
                            display: true,
                            text: "UTC",
                        }
                    }
                },
                plugins: {
                    datalabels: {
                        color: function(ctx) {
                            return ctx.dataset.labelColor 
                        },
                        formatter: function(value) {
                            return Math.round(value/3600);
                        }
                    },
                    legend: {
                        align: 'start',
                        display: false
                    },
                    tooltip: {
                        callbacks: {
                            label: function(context) {
                            let timeInSeconds = context.dataset.data[context.dataIndex]
                            let hours = Math.floor(timeInSeconds / 3600).toString().padStart(2, '0');
                            let minutes = Math.floor((timeInSeconds % 3600) / 60).toString().padStart(2, '0');
                            let seconds = (timeInSeconds % 60).toString().padStart(2, '0');
                            return context.dataset.label+": "+hours+"h "+minutes+"m "+seconds+"s";
                            }
                        }
                    }
                }
            },

            chartOptionsAlarms: {
                responsive: true,
                indexAxis: 'y',
                scales: {
                    x: {
                        grid: {
                            display: false
                        },
                        ticks: {
                            display: false
                        },
                        title: {
                            display: true,
                            text: this.$vuetify.lang.t('$vuetify.dashboard.statistics.alarm'),
                        }
                    },
                    y: {
                        grid: {
                            display: false
                        },
                        title: {
                            display: true,
                            text: "UTC",
                        }
                    },
                },
                plugins: {
                    datalabels: {
                        color: 'white'
                    },
                    legend: {
                        display: false
                    }
                }               
            },

            chartOptionsIntrusions: {
                responsive: true,
                indexAxis: 'y',
                scales: {
                    x: {
                        grid: {
                            display: false
                        },
                        ticks: {
                            display: false
                        },
                        title: {
                            display: true,
                            text: this.$vuetify.lang.t('$vuetify.dashboard.statistics.intrusion'),
                        }
                    },
                    y: {
                        grid: {
                            display: false
                        },
                        title: {
                            display: true,
                            text: "UTC",
                        }
                    },
                },
                plugins: {
                    datalabels: {
                        color: 'white'
                    },
                    legend: {
                        display: false
                    }
                }    
            },


            chartOptionsIncidents: {
                responsive: true,
                indexAxis: 'y',
                scales: {
                    x: {
                        grid: {
                            display: false
                        },
                        ticks: {
                            display: false
                        },
                        title: {
                            display: true,
                            text: this.$vuetify.lang.t('$vuetify.dashboard.statistics.incident'),
                        }
                    },
                    y: {
                        grid: {
                            display: false
                        },
                        title: {
                            display: true,
                            text: "UTC",
                        }
                    }
                },
                plugins: {
                    datalabels: {
                        color: 'white'
                    },
                    legend:{
                        display: false
                    }
                }
            }
        }
    },

    computed: {
         ...mapGetters({user: "StateUser"}),

        chartDataOperatingTime() {
            return {
                labels: this.operatingTimeLabels,
                datasets: [
                    {
                        label: this.$vuetify.lang.t('$vuetify.dashboard.statistics.operating'),
                        backgroundColor: this.operatingTimeBg,
                        data: this.operatingTimeData,
                        minBarLength: 20,
                        barThickness: 25,
                        labelColor: "white",
                    }
                ],
            }
        },

        chartDataAlarms() {
            return {
                labels: this.alarmsLabels,
                datasets: [
                    {
                        label: this.$vuetify.lang.t('$vuetify.dashboard.statistics.alarm'),
                        backgroundColor: this.alarmsBg,
                        data: this.alarmsData,
                        minBarLength: 20,
                        barThickness: 25,
                        labelColor: "white"
                    }
                ],
            }
        },

        chartDataIntrusions() {
            return {
                labels: this.intrusionsLabels,
                datasets: [
                    {
                        label: this.$vuetify.lang.t('$vuetify.dashboard.statistics.intrusion'),
                        backgroundColor: this.intrusionsBg,
                        data: this.intrusionsData,
                        minBarLength: 20,
                        barThickness: 25,
                        labelColor: "white"
                    }
                ],
            }
        },

        chartDataIncidents() {
            return {
                labels: this.incidentsLabels,
                datasets: [
                    {
                        label: this.$vuetify.lang.t('$vuetify.dashboard.statistics.network'),
                        backgroundColor: this.incidentsBg,
                        data: this.incidentsData,
                        minBarLength: 20,
                        barThickness: 25,
                        labelColor: "white"
                    },
                ],                
            }
        }
    },


    async mounted() {
        this.$root.$on('refreshDash', () => {
            this.refresh()
        }),
        this.refresh();
        const elm = await waitForElm("#bar-chart");
        let ctx = elm.getContext("2d");
        let gradient = ctx.createLinearGradient(0, 0, 400, 0);
        gradient.addColorStop(0, "rgba(37,77,153,1)");
        gradient.addColorStop(1, "rgba(76,180,221,1)");
        this.operatingTimeBg = gradient;
        this.alarmsBg = gradient;
        this.incidentsBg = gradient;
        this.intrusionsBg = gradient;
    },

    methods: {
        async getUtcSortByOperatingTime() {
            this.loadingOperating = true;
            try {
                const res = await axios.get('dashboard/utcSortByOperatingTime/'+this.user.orga);
                if (res.status == 200) {
                    this.operatingTimeLabels = [];
                    this.operatingTimeData = [];
                    for (const utc of res.data.utc_Sort_By_Operating_Time) {
                        this.operatingTimeLabels.push(utc.SERIAL_NB);
                        this.operatingTimeData.push(Math.trunc(parseInt(utc.OPERATING_TIME)));
                    }
                }
            } catch(err) {
                console.error(err);
            }
            setTimeout(() => {
                this.loadingOperating = false;
            }, 300)
        },

        async getUtcSortByAlarmCount(){
            this.loadingAlarmsCount = true;
            try {
                const res = await axios.get('dashboard/utcSortByAlarmCount/'+this.user.orga);
                if (res.status == 200) {
                    this.alarmsLabels = [];
                    this.alarmsData = [];
                    for (const utc of res.data.nbr_alarm_by_sensor) {
                        this.alarmsLabels.push(utc.SENSOR_SERIAL_NB);
                        this.alarmsData.push(utc.ALARM_COUNT);
                    }
                }
            } catch(err) {
                console.error(err);
            }
            setTimeout(() => {
                this.loadingAlarmsCount = false;
            }, 300);
        },

        async getUtcSortIncidents(){
            this.loadingIncidents = true;
            try {
                const res = await axios.get('dashboard/utcSortIncidents/'+this.user.orga);
                if (res.status == 200) {
                    this.incidentsLabels = [];
                    this.incidentsData = [];
                    for (const utc of res.data.nbr_incidents_by_sensor) {
                        this.incidentsLabels.push(utc.SERIAL_NB);
                        this.incidentsData.push(utc.CPT_DECONNECTION);
                    }
                }
            } catch(err) {
                console.error(err);
            }
            setTimeout(() => {
                this.loadingIncidents = false;
            }, 300)
        },

        async getUtcSortByIntrusionCount(){
            this.loadingIntrusions = true;
            try {
                const res = await axios.get('dashboard/utcSortByIntrusionCount');
                if (res.status == 200) {
                    this.intrusionsLabels = [];
                    this.intrusionsData = [];
                    for (const utc of res.data.nbr_intrusion_by_sensor) {
                        this.intrusionsLabels.push(utc.SENSOR_SERIAL_NB);
                        this.intrusionsData.push(utc.INTRUSION_COUNT);
                    }
                }
            } catch(err) {
                console.error(err);
            }
            setTimeout(() => {
                this.loadingIntrusions = false;
            }, 300);
        },


        refresh() {
            this.getUtcSortByOperatingTime();
            this.getUtcSortByAlarmCount();
            this.getUtcSortIncidents();
            this.getUtcSortByIntrusionCount();
        },
    }
}
</script>